module.exports = __webpack_public_path__ + "img/top.3c0a496e.png";